export const ENTRY_FEE_PER_PLAYER = 10;
export const AFC_FEE_PER_RACE = 20;
export const PLAYERS_PER_SQUAD = 3;

export const SHARES = {
  2: [60, 40],
  3: [50, 30, 20]
};

export function championRaceCount ({ squadCount, timesEachPairPlays, bracketRoundCount, bracketHasByes }) {
  if (squadCount < 2 || timesEachPairPlays < 1) return 0;
  const roundRobinRaces = (squadCount - 1) * timesEachPairPlays;
  const bracketRaces = bracketHasByes ? Math.max(0, bracketRoundCount - 1) : bracketRoundCount;
  return roundRobinRaces + bracketRaces;
}

export function leaguePayouts ({ squadCount, timesEachPairPlays, bracketRoundCount, bracketHasByes }) {
  const races = championRaceCount({ squadCount, timesEachPairPlays, bracketRoundCount, bracketHasByes });
  if (races <= 0 || squadCount < 2) return null;
  const players = squadCount * PLAYERS_PER_SQUAD;
  const entryFees = ENTRY_FEE_PER_PLAYER * races * players;
  const afcFee = AFC_FEE_PER_RACE * races;
  const pool = entryFees - afcFee;
  if (pool <= 0) return null;
  const shares = SHARES[Math.min(3, squadCount)];
  const byPlace = {};
  let remaining = pool;
  shares.forEach((share, i) => {
    const place = i + 1;
    const amount = i === shares.length - 1 ? remaining : Math.round((pool * share) / 100);
    byPlace[place] = amount;
    remaining -= amount;
  });
  return { races, players, entryFees, afcFee, pool, byPlace };
}